// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8ea908284373b27efdf26f247c2e4ed943897873.chunk.bundle.js";
};